// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"125":"accordian","851":"media-carousel-row"}[chunkId] + "." + {"125":"6b4154acdf0e","851":"8e084dbed8a0"}[chunkId] + ".bundle.js";
};